import { isEmailInAllowlist } from "../../common/helpers/emailAllowlist.helpers";

export const PURCHASE_ORDER_DASHBOARD_ALLOWED_EMAILS = [
  "wandson.helber@gmail.com",
  "pollyalvesdossantos@gmail.com",
  "rafaelpaulin@gmail.com",
  "manasses.arteman@gmail.com",
] as const;

export function canAccessPurchaseOrderDashboard(
  email: string | undefined,
): boolean {
  return isEmailInAllowlist(email, PURCHASE_ORDER_DASHBOARD_ALLOWED_EMAILS);
}
